import { statusEn } from './en'
import { statusNl } from './nl'

export { statusEn, statusNl }

export type StatusKey = keyof typeof statusEn

/**
 * All status translations keyed by locale.
 * Intended to be merged into vue-i18n messages under the `status` namespace.
 */
export const statusMessages = {
  en: { status: statusEn },
  nl: { status: statusNl },
} as const

/**
 * Get a status label for a given locale.
 * Falls back to the English label, then to the raw status string.
 */
export function getStatusLabel(status: string, locale: 'en' | 'nl' = 'en'): string {
  const map = locale === 'nl' ? statusNl : statusEn
  return (map as Record<string, string>)[status] || status.replace(/_/g, ' ')
}
